import { render, staticRenderFns } from "./JourneyBuilderMenuBrickComposer.vue?vue&type=template&id=79db020b&"
import script from "./JourneyBuilderMenuBrickComposer.vue?vue&type=script&lang=js&"
export * from "./JourneyBuilderMenuBrickComposer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79db020b')) {
      api.createRecord('79db020b', component.options)
    } else {
      api.reload('79db020b', component.options)
    }
    module.hot.accept("./JourneyBuilderMenuBrickComposer.vue?vue&type=template&id=79db020b&", function () {
      api.rerender('79db020b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Menu/JourneyBuilderMenuBrickComposer.vue"
export default component.exports